import { styled } from "@mui/material/styles";
import { Dialog, DialogContentText } from "@mui/material";

export const TicketDialog = styled(Dialog)({
  "& .react-draggable > svg": {
    bottom: "0px",
    right: "0px",
    position: "absolute",
    transform: "rotate(45deg)",
    cursor: "grab",
  },
});

export const ContentWrapper = styled(DialogContentText)({
  maxWidth: "100%",
  minWidth: "300px",
  minHeight: "300px",
});
